import { useState, useCallback, useMemo, createContext } from 'react';
import {
  NotificationVariant,
  NotificationContextType,
  Notification,
} from './notification-types';

export const NotificationCtx = createContext<NotificationContextType>(
  undefined as any
);

/**
 * Notification functionality for provider (evidence component).
 */
export function useNotification({ timeout }: { timeout: number }) {
  const [notification, setNotification] = useState<Notification>({
    message: '',
    variant: NotificationVariant.SUCCESS,
    open: false,
  });

  /**
   * Closes notification snackbar.
   */
  const closeNotification = useCallback(() => {
    setNotification((notification) => ({
      ...notification,
      open: false,
    }));
  }, []);

  /**
   * Shows notification and set timer to close it after timeout.
   */
  const showNotification = useCallback(
    (message: string, variant: NotificationVariant, localTimeout = timeout) => {
      setNotification({
        message,
        variant,
        open: true,
      });

      if (localTimeout !== 0) {
        setTimeout(() => {
          closeNotification();
        }, localTimeout);
      }
    },
    [timeout, closeNotification]
  );

  const notificationContext: NotificationContextType = useMemo(
    () => ({
      showNotification,
      closeNotification,
    }),
    [showNotification, closeNotification]
  );

  return {
    notification,
    notificationContext,
  };
}
